import DivisionHistoryContainer from '../../../containers/division/divisionHistory/divisionHistoryContainer';

export default function DivisionDate() {
  return (
    <DivisionHistoryContainer />
  );
}
